(function () {
  const tigScript = () => {
    console.log("TIG Script Initialized");

    // Track if we've recently had a form submission
    let recentFormSubmission = false;
    let formSubmissionTimer = null;

    // Function to publish custom events to Shopify Analytics
    const publishCustomEvent = (eventName, eventData = {}) => {
      console.log("Publishing custom event:", eventName, eventData);
      
      if (window.Shopify && window.Shopify.analytics) {
        window.Shopify.analytics.publish(eventName, {
          ...eventData,
          url: window.location.href,
          timestamp: new Date().toISOString()
        });
      }
    };

    // Enhanced Zoho form detection
    const detectZohoSubmission = () => {
      // Method 1: Listen for all form submissions and check for Zoho indicators
      document.addEventListener("submit", (event) => {
        const form = event.target;
        console.log("Form submitted:", form.id, form.className, form.action);
        
        // Set flag that we just had a form submission
        recentFormSubmission = true;
        clearTimeout(formSubmissionTimer);
        formSubmissionTimer = setTimeout(() => {
          recentFormSubmission = false;
        }, 5000); // Reset after 5 seconds
        
        // Check if it's a Zoho form
        if (form.id === "frmNewLead" || 
            form.action?.includes("zoho") || 
            form.className?.includes("zf-") ||
            form.querySelector('[name*="zf_"]')) {
          console.log("Zoho form detected and submitted");
          publishCustomEvent("measure_and_quote_submission", {
            form_name: "measure_and_quote_submissions",
            source: "zoho_form_direct"
          });
        }
        
        // Existing form handling
        if (form.id === "measure_and_quote_submissions_id") {
          publishCustomEvent("measure_and_quote_submission", {
            form_name: "measure_and_quote_submissions"
          });
        } else if (form.id === "ContactForm") {
          publishCustomEvent("contact_form_submission", {
            form_name: "contact_us_submissions"
          });
        }
      });

      // Method 2: Watch for Zoho success indicators (ONLY after form submission)
      const observer = new MutationObserver((mutations) => {
        // Only proceed if we recently had a form submission
        if (!recentFormSubmission) return;
        
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) {
              const text = node.textContent?.toLowerCase() || '';
              const className = node.className || '';
              
              // More specific success detection for Zoho forms
              if ((text.includes('thank you') && text.includes('message')) ||
                  (text.includes('successfully submitted')) ||
                  className.includes('zf-success') ||
                  (node.id?.includes('success') && node.id?.includes('zf'))) {
                console.log("Zoho success indicator detected after form submission:", text, className);
                publishCustomEvent("measure_and_quote_submission", {
                  form_name: "measure_and_quote_submissions",
                  source: "zoho_success_detected"
                });
                // Reset the flag to prevent duplicate events
                recentFormSubmission = false;
              }
            }
          });
        });
      });
      
      observer.observe(document.body, { childList: true, subtree: true });
    };

    // Zoho iframe message listener
    window.addEventListener('message', function(event) {
      console.log("Message received from:", event.origin, event.data);
      
      try {
        // Handle both string and object data
        const data = typeof event.data === 'string' ? event.data : JSON.stringify(event.data);
        
        if ((event.origin.includes('zoho') || event.origin.includes('zohopublic')) && 
            (data.includes('success') || data.includes('submitted') || data.includes('complete'))) {
          console.log("Zoho iframe success message detected");
          publishCustomEvent("measure_and_quote_submission", {
            form_name: "measure_and_quote_submissions",
            source: "zoho_iframe_message"
          });
        }
      } catch (e) {
        console.log("Error processing message:", e);
      }
    });

    // Link click tracking
    document.addEventListener("click", (event) => {
      const target = event.target.closest("a");
      if (!target) return;

      const href = target.href;

      // Store finder clicks
      if (href.includes("/pages/our-stores") || href.includes("stores")) {
        publishCustomEvent("store_finder_click", {
          link_href: href
        });
      }

      // Phone number clicks
      if (href.startsWith("tel:")) {
        publishCustomEvent("phone_number_click", {
          link_href: href,
          phone_number: href.replace("tel:", "")
        });
      }

      // File downloads
      const fileExtensions = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".zip", ".csv"];
      const isFileDownload = fileExtensions.some((ext) =>
        href.toLowerCase().endsWith(ext)
      );

      if (isFileDownload) {
        publishCustomEvent("file_download", {
          link_href: href,
          file_type: href.split('.').pop().toLowerCase()
        });
      }
    });

    // Initialize Zoho form detection
    detectZohoSubmission();
  };

  // Initialize the script when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tigScript);
  } else {
    tigScript();
  }
})();
